import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ace-loading',
  templateUrl: './ace-loading.component.html',
  styleUrls: ['./ace-loading.component.scss'],
  standalone: false
})
export class AceLoadingComponent {
  @Input() height = null;
}
